<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Notification</h2>
    </div>
    <div class="page-section-body">
        <app-tablev2 #table></app-tablev2>
    </div>
</div>
